module.exports = __webpack_public_path__ + "img/46.61f74fa7.jpg";